import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import EntriesRoute from "./EntriesRoute";

// const EntriesWithProvider = React.lazy(() => import("./EntriesRoute"));

export const EntriesRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <EntriesRoute />
    </Suspense>
  );
};
